module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/2_1cccaa96f3c39ad7bf6b7f001826d431.png";